// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"Dropdown_dropdown__3XS0X","select":"Dropdown_select__3TReD"};